export default {
  test: 'test',
};


// WEBPACK FOOTER //
// ./src/locales/zh-CN/test.ts